// @flow
export const ADD_SELECTED_ITEMS = 'ADD_SELECTED_ITEMS';
